 import React from 'react';
import './plant.css';

import Navbar from "../../components/Navbar";
import SecondNavbar from "../../components/SecondNavbar";
import Footer from "../../components/Footer";

import forestImg from "../../assets/Forest.jpg";
import urbanImg from "../../assets/urbanImg.jpg";
import neemImg from "../../assets/neemImg.jpg";
import banyanImg from "../../assets/banyanImg.jpg";
import peepalImg from "../../assets/peepalImg.jpg";

const PlantPage = () => {
  return (
    <div className="ecovibe-journal plant-theme">
      <Navbar />
      <SecondNavbar />

      <header className="journal-hero">
        <div className="hero-overlay plant-hero-right">
          <h1>Plants: The Green Architecture</h1>
          <p>Building a Greener Pakistan, One Tree at a Time</p>
        </div>
      </header>

      <section className="intro-section">
        <div className="intro-card">
          <div className="intro-text-block">
            <span className="intro-tag">ECOVIBE REPORT</span>
            <h2>Introduction: Why Flora Matters</h2>
            <p>Plants are the most sophisticated biological technology on Earth. They are not merely decoration; they are the foundation of our climate, air quality, and mental health. This report explores how our local Pakistani ecosystem relies on 'Green Architecture' and why preserving it is the most important social responsibility of our time.</p>
          </div>
          <div className="intro-image-block">
            <img src={forestImg} alt="Green Forest of Pakistan" />
          </div>
        </div>
      </section>

      <div className="journal-grid">
        <main className="main-content">
          <article className="article-body">
            
            <h2>The National Goal: How Many Trees?</h2>
            <p>Ecological science suggests that for a healthy environment, a country should ideally have at least 25% of its land area under forest cover. Currently, Pakistan is significantly below this threshold, which directly contributes to our vulnerability to extreme climate change and frequent heatwaves. Achieving this requires a massive transition from 'ceremonial' tree planting to 'sustained' forest management, focusing on restoring the natural green belts that once spanned our plains and mountains.</p>
            
            <h2>Why are we losing our plants?</h2>
            <p>The primary driver is <strong>Urban Sprawl</strong>—the uncontrolled expansion of concrete structures. As cities grow, fertile topsoil is buried under cement, preventing natural growth. Additionally, the industrial sector frequently clears out critical forest buffers without any replacement strategy, leading to a permanent loss of natural air-filtration systems. We often prefer fancy, decorative trees that are not used to our local weather, causing them to wither quickly.</p>
            <img src={urbanImg} alt="Urban Sprawl" className="featured-img" />

            <h2>Environmental Impact</h2>
            <p>When trees are cut down, the environment loses its natural cooling system, creating the <strong>"Urban Heat Island"</strong> effect, where cities get much hotter than the countryside. Additionally, the loss of trees leads to <strong>Soil Erosion</strong>. Without strong roots to hold the earth, heavy monsoon rains wash away the top layer of our soil. This also destroys <strong>Biodiversity Corridors</strong> for local birds and insects, leading to a collapse in natural pollination cycles.</p>
          </article>
        </main>

        <aside className="sidebar">
          <div className="sidebar-card">
            <h3>Quick Facts</h3>
            <p><strong>CO2 Absorption:</strong> 22kg/year per tree</p>
            <p><strong>Mental Health:</strong> Reduces stress by 30%</p>
            <p><strong>Target:</strong> 25% Forest Cover</p>
            <p><strong>Did You Know?</strong> A mature tree absorbs ~22kg of CO2 per year</p>
          </div>
        </aside>
      </div>

      <section className="action-plan">
        <h2>Preservation & Sustainable Usage</h2>
        <div className="action-grid">
          <div className="action-card"><h4>Community Stewardship</h4><p>Involve local neighborhoods in 'Adopting a Tree.'</p></div>
          <div className="action-card"><h4>Waste-to-Growth</h4><p>Implement household composting to provide organic fertilizer for urban soil.</p></div>
          <div className="action-card"><h4>Water Security</h4><p>Moving towards 'Drip Irrigation' and using greywater to ensure saplings survive.</p></div>
        </div>
      </section>

      <section className="data-highlight">
        <h3>Our Future Vision: A Greener Pakistan</h3>
        <p><em>"Looking ahead, the goal of Ecovibe is to bridge the gap between technology and nature. Our vision is a future where every urban citizen in Pakistan is a steward of their local environment. Join the movement. Plant a seed, nurture a life, and help us reclaim our green heritage."</em></p>
      </section>

      <section className="benefits-section">
        <h2>The Local Heroes: Native Trees of Pakistan</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <img src={neemImg} alt="Neem" />
            <h4>Neem</h4>
            <p>Known as the 'Village Pharmacy', it is an incredible air purifier and natural pest repellent that is perfectly adapted to our climate.</p>
          </div>
          <div className="benefit-card">
            <img src={banyanImg} alt="Banyan" />
            <h4>Banyan</h4>
            <p>A giant ecosystem that acts like a home for hundreds of bird species and provides deep, cool shade that lasts for centuries.</p>
          </div>
          <div className="benefit-card">
            <img src={peepalImg} alt="Peepal" />
            <h4>Peepal</h4>
            <p>A master of oxygen production that even works during the night, acting as a vital ally in combating extreme urban temperatures.</p>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <h2>By The Numbers</h2>
        <div className="stats-grid">
          <div className="stat-item">
            <h3>22kg</h3>
            <p>CO2 Absorbed Per Tree / Year</p>
          </div>
          <div className="stat-item">
            <h3>30%</h3>
            <p>Stress Reduction by Green Spaces</p>
          </div>
          <div className="stat-item">
            <h3>25%</h3>
            <p>National Forest Cover Target</p>
          </div>
          <div className="stat-item">
            <h3>1</h3>
            <p>Tree Can Cool 2 Houses</p>
          </div>
        </div>
      </section>

      <section className="journal-challenges">
        <h2>The Challenges: Protecting Our Flora</h2>
        <ul className="challenges-list">
          <li><strong>Urban Sprawl:</strong> Concrete expansion burying fertile soil</li>
          <li><strong>Industrial Clearing:</strong> Loss of forest buffers without replacement</li>
          <li><strong>Wrong Species:</strong> Decorative trees not adapted to local weather wither quickly</li>
        </ul>
      </section>

      <div className="fact-box">
        <h3>Ecovibe Quick Fact</h3>
        <p>Join the movement. <strong>Plant a seed, nurture a life</strong>, and help us reclaim our green heritage.</p>
      </div>

      <Footer />
    </div>
  );
};

export default PlantPage;